import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '../environment.service';
import {Observable} from 'rxjs';
import {IChangeProduct} from '../../common/models/interfaces';
import {ApiClient} from './userway-api.service';
import {
  AgencyAccountUpdateBillingDescriptorDto,
  PostNewslettersBodyDto,
  PostTrackBodyDto,
  UwV2ExposedAgencyAccountsBillingDescriptorUpdateData,
  UwV2ExposedAgencyAccountsContextDetailData,
  UwV2ExposedAgencySubscriptionsSitesBillingDetailData,
} from '../../../userway/sdk/UserWayApiClient';

const YOUTUBE_API_KEY = 'AIzaSyA9_T7fq2NZAOzuS7cw0Wvtqnzx320Icbw';
const AGENCY_API_PATH = 'uw/v2/exposed/agency/subscriptions';

@Injectable({
  providedIn: 'root',
})
export class AgencyApiService {
  constructor(
    private env: EnvironmentService,
    private http: HttpClient,
    private apiClient: ApiClient,
  ) {}

  enableProduct(data: IChangeProduct, subscriptionId: number, siteId: number): Observable<any> {
    const url = `${this.env.apiUrl.apiBase}${AGENCY_API_PATH}/${subscriptionId}/sites/${siteId}/enable`;

    return this.http.post(url, data);
  }

  disableProduct(data: IChangeProduct, subscriptionId: number, siteId: number): Observable<any> {
    const url = `${this.env.apiUrl.apiBase}${AGENCY_API_PATH}/${subscriptionId}/sites/${siteId}/disable`;
    return this.http.post(url, data);
  }

  getAgencyAccountSummary(userId: string): Observable<UwV2ExposedAgencyAccountsContextDetailData> {
    const request = this.apiClient.api.agency.uwV2ExposedAgencyAccountsContextDetail(userId);
    return this.apiClient.fetch(request);
  }

  addBillingDescriptor(
    data: {
      userId: string;
    } & AgencyAccountUpdateBillingDescriptorDto,
  ): Observable<UwV2ExposedAgencyAccountsBillingDescriptorUpdateData> {
    const request = this.apiClient.api.accounts.uwV2ExposedAgencyAccountsBillingDescriptorUpdate(data.userId, data);
    return this.apiClient.fetch(request);
  }

  getAgencyVideoList(playlistId: string) {
    const url = 'https://www.googleapis.com/youtube/v3/playlistItems';

    const params: Record<string, string> = {
      part: 'snippet',
      key: YOUTUBE_API_KEY,
      playlistId,
      maxResults: '50',
    };

    const queryString = new URLSearchParams(params).toString();
    const requestUrl = `${url}?${queryString}`;

    return this.http.get(requestUrl, {headers: {authorization: 'none'}});
  }

  trackAssetsDownloads(assetName: string): Observable<any> {
    const data: PostTrackBodyDto = {
      assetName,
    };

    const request = this.apiClient.api.misc.uwV2BrandAssetsTrackCreate(data);
    return this.apiClient.fetch(request);
  }

  trackNewslettersDownloads(newsletter: string): Observable<any> {
    const data: PostNewslettersBodyDto = {
      newsletter,
    };

    const request = this.apiClient.api.misc.uwV2TrackingNewslettersCreate(data);
    return this.apiClient.fetch(request);
  }

  getAgencyVideo(id: string) {
    const url = 'https://www.googleapis.com/youtube/v3/videos';

    const params: Record<string, string> = {
      part: 'snippet',
      key: YOUTUBE_API_KEY,
      id,
    };

    const queryString = new URLSearchParams(params).toString();
    const requestUrl = `${url}?${queryString}`;

    return this.http.get(requestUrl, {headers: {authorization: 'none'}});
  }

  getAgencySiteBillingDetails(
    agencySubscriptionId: number,
    siteId: number,
  ): Observable<UwV2ExposedAgencySubscriptionsSitesBillingDetailData> {
    const request = this.apiClient.api.agency.uwV2ExposedAgencySubscriptionsSitesBillingDetail(
      String(agencySubscriptionId),
      String(siteId),
    );
    return this.apiClient.fetch(request);
  }

  transferLicense(params: {siteIdFrom: number; siteIdTo: number; agencySubscriptionId: number}) {
    const data = {
      siteIdFrom: params.siteIdFrom,
      siteIdTo: params.siteIdTo,
    };

    const request = this.apiClient.api.agency.uwV2ExposedAgencySubscriptionsSitesTransferCreate(
      params.agencySubscriptionId.toString(),
      data,
    );

    return this.apiClient.fetch(request);
  }
}
